
export default {
  props: {
    list: {
      // label数据
      type: Array,
      default: () => []
    },
    index: {
      // 键值
      type: [Number, String],
      default: 0
    },
    ismore: {
      // 是否有可以展开的按钮
      type: Boolean,
      default: true
    },
    specialtyarr: {
      // 特色标签
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      labelmore: false,
      selectshow: false
    }
  },
  mounted() {
    if (!this.ismore) return
    this.setele()
  },
  methods: {
    setele() {
      // 计算labei下拉
      const ele = document.getElementById(`trader-list-add${this.index}`)
      if (ele && ele.clientHeight > 34) this.selectshow = true
    }
  }
}
